import classnames from 'classnames';

import {A} from 'components/atoms/LinksAndButtons/A';
import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {Icon} from 'components/atoms/Media/Icon';
import {P} from 'components/atoms/Text/P';
import {Margin, ParagraphSize, HeadlineLevel} from 'features/ui/enums';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import './style.scss';
import {SiteIcons} from "features/template/types";
import {Headline} from '@atoms/Text/Headline';

interface Props {
    icon: SiteIcons | string;
    headline: string;
    href: string;
    small?: boolean;
    noButton?: boolean;
    'data-test-id'?: string;
}

export const IconLink: React.FunctionComponent<Props> = (props) => {

    const isMobile = useDeviceStore(selectIsMobile);

    const classes = classnames('icon-link', {
        'icon-link--small': props.small,
    });

    return (
        <A 
            className={classes} 
            href={props.href} 
            data-test-id={props["data-test-id"]} 
            route 
            title={props.headline}
        >
            <div className="img-wrapper">
                <Icon name={props.icon.toLowerCase()} size={props.small ? 32 : 48} sizeL />
            </div>

            {props.small ?
                <P size={isMobile ? ParagraphSize.S : undefined}>{props.headline}</P> :
                <Headline level={HeadlineLevel.H3} margin={!isMobile ? Margin.L : undefined}>{props.headline}</Headline>
            }
            {!props.noButton &&
                <Button 
                    onClick={() => {}} 
                    buttonColor={ButtonColor.DEFAULT} 
                    buttonSize={ButtonSize.DEFAULT} 
                    buttonType={ButtonType.GHOST} 
                >
                    <FormattedMessage id="jm.components.IconLink.readMore" />
                </Button>
            }
        </A>
    )
};

